(function () {
	document.addEventListener("DOMContentLoaded", () => {

		const img = document.getElementById("vg-nav-arrow");
		if (!img) {
			return;
		}

		window.addEventListener("scroll", function() {
			if (window.scrollY > 100) {
				img.style.display = "block";
			} else {
				img.style.display = "none";
			}
		});
	});
})();
